
import { Image } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import React from 'react';

interface Props {
    image: any;
}

const ImageBanner = (props:Props) => {
    return (
        <Content className="image-block">
           {/* <Image  preview={false} src={props.image}/> */}
        </Content>
    )
}

export default ImageBanner;